var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pptPath)?_c('div',{staticClass:"embedbox"},[_c('embed',{ref:"myIframe",attrs:{"id":"iframe","src":_vm.pptPath,"width":"100%","height":"100%","type":"application/pdf"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }